import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AthleteStatisticsRoutingModule } from "./athlete-statistics-routing.module";
import { ComponentsModule, ServicesModule } from "world-archery-lib";
import { CommonPageComponentsModule } from "../../common-page-components/common-page-components.module";
import { BootstrapAthleteStatisticsComponent } from "./components/bootstrap-athlete-statistics/bootstrap-athlete-statistics.component";
import { AthleteSeasonStatisticsComponent } from "./components/athlete-season-statistics/athlete-season-statistics.component";
import { AthleteWorldRankingStatisticsComponent } from "./components/athlete-world-ranking-statistics/athlete-world-ranking-statistics.component";
import { AthleteCareerStatisticsComponent } from "./components/athlete-career-statistics/athlete-career-statistics.component";
import { LineChartModule, PieChartModule } from "@swimlane/ngx-charts";
import { FiltersAthleteWorldRankingsStatisticsService } from './services/filters-athlete-world-rankings-statistics.service';

@NgModule({
  declarations: [
    BootstrapAthleteStatisticsComponent,
    AthleteSeasonStatisticsComponent,
    AthleteWorldRankingStatisticsComponent,
    AthleteCareerStatisticsComponent
  ],
  providers:[

  ],
  imports: [
    CommonModule,
    AthleteStatisticsRoutingModule,
    CommonPageComponentsModule,
    ComponentsModule,
    LineChartModule,
    PieChartModule
  ]
})
export class AthleteStatisticsModule {}
